import React, { FC, useState, useEffect } from 'react';
import { service } from '../../../services/AxiosServices';
import CrewScreen from '../atoms/CrewScreen';
import axios from '../../../config/axios';
import WindowHeightComponent from '../../Layouts/WindowHeight';

interface Props {

  crewId?: string;
  name: string;
  path?: boolean;
}

const CrewEditForm: FC<Props> = ({ crewId, path, name }) => {

  return (
    <>



        <div className=''>
          <CrewScreen crewName={ name} crewId={crewId} />

        </div>
    

    </>
  );
};

export default CrewEditForm;
